import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils.js";

const baseUrl = "/api/sif/pripustObnasanjeSamice";

export const fetchMatingBehaviorFemale = createAsyncThunk(
  "matingBehaviorFemale/list",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchMatingBehaviorFemalePage = createAsyncThunk(
  "matingBehaviorFemale/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchMatingBehaviorFemaleBySifra = createAsyncThunk(
  "matingBehaviorFemale/byCode",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(`${baseUrl}/${sifra}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const matingBehaviorFemaleSlice = createSlice({
  name: "matingBehaviorFemale",
  initialState: {
    page: null,
    list: [],
    byId: {},
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMatingBehaviorFemale.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(fetchMatingBehaviorFemale.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchMatingBehaviorFemale.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMatingBehaviorFemalePage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchMatingBehaviorFemalePage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchMatingBehaviorFemalePage.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMatingBehaviorFemaleBySifra.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMatingBehaviorFemaleBySifra.fulfilled, (state, action) => {
        state.isLoading = false;
        const item = action.payload;
        if (item?.sifra) {
          state.byId[item.sifra] = item;
          state.details = item.sifra;
        }
      })
      .addCase(fetchMatingBehaviorFemaleBySifra.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default matingBehaviorFemaleSlice.reducer;
